import { useMemo } from 'react'

import { useAuthUser } from '~/hooks/useAuthUser'
import { BackendPasskey } from '~/types'

export const useUserPasskeys = (): {
  passkeys: BackendPasskey[]
  passkeyIds: Set<string>
  isLoading: boolean
} => {
  const { user, isLoading } = useAuthUser()
  const { passkeys, passkeyIds } = useMemo(() => {
    const passkeys = user?.passkeys ?? []
    return { passkeys, passkeyIds: new Set(passkeys.map((p) => p.id)) }
  }, [user?.passkeys])
  return { passkeys, passkeyIds, isLoading }
}
